import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { lightModeOptions } from './configuration/lightMode';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
    ...lightModeOptions
});

const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
if (trackingId) {
    try {
        ReactGA.initialize(trackingId, {
            gtagOptions: {
                // Ensure consistent client ID tracking
                send_page_view: false, // We'll handle page views manually via react-router
                cookie_flags: 'SameSite=None;Secure', // Required for cross-domain tracking
            },
            gaOptions: {
                // Extend session timeout to 30 minutes of inactivity
                cookieExpires: 63072000, // 2 years in seconds
                siteSpeedSampleRate: 100, // Track all site speed samples for better performance data
            }
        });
    } catch (error) {
        console.error('Failed to initialize Google Analytics:', error);
        // Continue without GA - don't break the app
    }
} else {
    console.warn('Google Analytics tracking ID not found in environment variables');
}

root.render(
  <ErrorBoundary>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
